import React from 'react'
import { Skeleton } from '@mui/material';

const SkeletonNewsDetail = () => {
    return (
        <>
            <Skeleton height={100} />
            <Skeleton height={300} />
            <Skeleton height={100} />
            <Skeleton height={100} />
        </>
    )
}
export default SkeletonNewsDetail;
